import { useRequest } from 'ahooks'
import { Form, Modal, ModalProps } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { DevlopForm } from '../../devlop-form.component'
import { Devlop } from '../../devlop.schema'

interface DevlopEditProps extends ModalProps {
  devlop: Devlop
  onCancel: () => void
}

export const DevlopEdit: React.FC<DevlopEditProps> = ({ devlop, ...props }) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const { run: updateDevlop, loading } = useRequest(
    (data) => ({
      url: `/api/devlop/patch/${devlop.selfId}`,
      method: 'patch',
      data,
    }),
    {
      manual: true,
      onSuccess: () => {
        props.onCancel()
      },
    }
  )

  return (
    <Modal
      destroyOnClose
      width={'80%'}
      maskClosable={false}
      title={`${t('edit')}：${devlop.name}`}
      okText={t('save')}
      okButtonProps={{ loading }}
      onOk={() => form?.submit()}
      {...props}
    >
      {devlop && <DevlopForm form={form} devlop={devlop} onSubmit={updateDevlop} />}
    </Modal>
  )
}
